module.exports = __webpack_public_path__ + "ico-pisek.svg?59aca7f523ab7317a1289db48069e580";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ico-pisek.svg
// module id = 213
// module chunks = 0